"use strict";

module.exports = function () {
  if (this && this.parent) {
    return this.parent().isVisible;
  }

  return this && this.isVisible;
};